export const   GET_HOME_APPS = 'GET_HOME_APPS';
export const   GET_HOME_APPS_SUCCESS = 'GET_HOME_APPS_SUCCESS';
export const   GET_HOME_APPS_ERROR = 'GET_HOME_APPS_ERROR';

export const   GET_TV_HOME_APPS = 'GET_TV_HOME_APPS';
export const   GET_TV_HOME_APPS_SUCCESS = 'GET_TV_HOME_APPS_SUCCESS';
export const   GET_TV_HOME_APPS_ERROR = 'GET_TV_HOME_APPS_ERROR';

export const   UPDATE_HOME_APPS_COMMUNITY = 'UPDATE_HOME_APPS_COMMUNITY';
export const   UPDATE_HOME_APPS_COMMUNITY_SUCCESS = 'UPDATE_HOME_APPS_COMMUNITY_SUCCESS';
export const   UPDATE_HOME_APPS_COMMUNITY_ERROR = 'UPDATE_HOME_APPS_COMMUNITY_ERROR';

export const   UPDATE_HOME_APPS_RESIDENT = 'UPDATE_HOME_APPS_RESIDENT';
export const   UPDATE_HOME_APPS_RESIDENT_SUCCESS = 'UPDATE_HOME_APPS_RESIDENT_SUCCESS';
export const   UPDATE_HOME_APPS_RESIDENT_ERROR = 'UPDATE_HOME_APPS_RESIDENT_ERROR';

export const   UPDATE_TV_HOME_APPS_COMMUNITY = 'UPDATE_TV_HOME_APPS_COMMUNITY';
export const   UPDATE_TV_HOME_APPS_COMMUNITY_SUCCESS = 'UPDATE_TV_HOME_APPS_COMMUNITY_SUCCESS';
export const   UPDATE_TV_HOME_APPS_COMMUNITY_ERROR = 'UPDATE_TV_HOME_APPS_COMMUNITY_ERROR';